(function () {
  "use strict";

  var btn = document.getElementById("scrollTopBtn");
  if (!btn) return;

  var showAfter = parseInt(btn.getAttribute("data-show-after"), 10) || 500;

  function onScroll() {
    btn.classList.toggle("is-visible", window.scrollY > showAfter);
  }

  btn.addEventListener("click", function () {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
})();
